import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

export interface SeriesPoint {
  label: string;
  value: number;
}

/** Reusable area chart used for ride volume / revenue trend cards. */
export function LineAreaChart({
  data,
  color = "#0F6B5C",
  valueFormatter,
  height = 220,
}: {
  data: SeriesPoint[];
  color?: string;
  valueFormatter?: (v: number) => string;
  height?: number;
}) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={data} margin={{ top: 4, right: 8, left: 0, bottom: 0 }}>
        <defs>
          <linearGradient id="chartFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity={0.35} />
            <stop offset="100%" stopColor={color} stopOpacity={0.02} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#E3DDCB" vertical={false} />
        <XAxis
          dataKey="label"
          tick={{ fontSize: 11, fill: "#5B6660" }}
          axisLine={{ stroke: "#E3DDCB" }}
          tickLine={false}
        />
        <YAxis
          tick={{ fontSize: 11, fill: "#5B6660" }}
          axisLine={false}
          tickLine={false}
          width={40}
          tickFormatter={valueFormatter}
        />
        <Tooltip
          formatter={(value: number) => (valueFormatter ? valueFormatter(value) : value)}
          contentStyle={{
            background: "#FCFBF7",
            border: "1px solid #E3DDCB",
            borderRadius: 8,
            fontSize: 12,
          }}
        />
        <Area
          type="monotone"
          dataKey="value"
          stroke={color}
          strokeWidth={2}
          fill="url(#chartFill)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
